<template>
  <div>
    <YaTeLoginForm />
  </div>
</template>

<script lang="ts">
import YaTeLoginForm from '~/components/YaTe/YateLoginForm/YateLoginForm.vue'
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaLYTATags } from '~/utility/constants/metaTags'

const options = {
  async setup() {
    definePageMeta({
      layout: 'yate-simple'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'yahoo',
    })
    return {
      title: '受講生ログイン | テックアカデミー',
      meta: [
        ...metaLYTATags(
          {
            keywords:
              'プログラミング, ブートキャンプ, エンジニア, パーソナルメンター',
            noIndexNofollow: false,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    YaTeLoginForm,
  }
}

export default defineNuxtComponent(options)
</script>
